module.exports = __webpack_public_path__ + "static/img/h_50@2x.dfac427a.png";